import { format, parseISO } from 'date-fns';
import type { ProviderReferral } from '../../../../../js/api/models/ProviderReferral';
import { ReferralMilestoneItem } from './ReferralMilestoneItem';

interface ReferralCardProps {
  referral: ProviderReferral;
}

function formatProviderName(referral: ProviderReferral): string {
  const p = referral.referred_provider;
  const prefix = p.prefix_name ? `${p.prefix_name} ` : '';
  const first = p.preferred_name ?? p.first_name ?? '';
  const last = p.last_name ?? '';
  return `${prefix}${first} ${last}`.trim();
}

export function ReferralCard({ referral }: ReferralCardProps) {
  const providerName = formatProviderName(referral);
  const joinedDate = (() => {
    try {
      return format(parseISO(referral.referred_at), 'MMM d, yyyy');
    } catch {
      return referral.referred_at;
    }
  })();

  return (
    <div className="tw:grid tw:grid-cols-2 tw:gap-2 tw:border tw:border-zinc-200 tw:rounded-lg tw:bg-white tw:p-4">
      <div className="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col tw:justify-center">
        <p className="tw:!mb-1 tw:font-semibold">{providerName}</p>
        <p className="tw:!mb-1 tw:text-xs tw:italic tw:text-zinc-400">{referral.program?.title}</p>
        <p className="tw:text-sm tw:font-normal tw:text-zinc-400">Joined {joinedDate}</p>
      </div>
      <div className="tw:flex tw:flex-shrink-0 tw:gap-6">
        {referral.program?.milestones?.map((milestone) => {
          const payable = referral.payable?.find((p) => p.program_milestone_id === milestone.id);
          return (
            <ReferralMilestoneItem key={milestone.id} milestone={milestone} payable={payable} />
          );
        })}
      </div>
    </div>
  );
}
